module.exports = __webpack_public_path__ + "img/kloofendal_48d_partly_cloudy_2k.c217c8bc.png";